import { Tooltip } from '@mui/material';
import { csmHashById } from 'CsmModule/constants';
import BaseSelectorWithArrow from 'components/BaseSelectorWithArrow';
import { MouseEventHandler } from 'react';

export const CsmSelector = ({
  accountId,
  onClick,
  tooltip = '',
  disabled,
}: {
  disabled?: boolean;
  accountId: Nullable<number>;
  onClick: MouseEventHandler<HTMLElement>;
  tooltip?: string;
}) => {
  const name = accountId ? csmHashById[accountId]?.name || 'Set CSM' : 'Set CSM';

  return (
    <Tooltip title={tooltip}>
      {/*
        Withholding onClick is the whole disable mechanism: BaseSelectorUI keys
        both the click and its greyed `.disabled` style off the handler being
        absent. `disabled` was declared in the props type but never read, so
        callers could pass it and silently get nothing.
      */}
      <BaseSelectorWithArrow onClick={disabled ? undefined : onClick} label={name} />
    </Tooltip>
  );
};
